var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkMapg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07137 0C1.82234 0 0 1.6432 0 4.07137C0 4.94589 0.255682 5.5908 0.646533 6.28456L3.75706 11.8167C3.89548 12.061 4.24725 12.061 4.38567 11.8167L7.4962 6.28456C7.88705 5.58918 8.14273 4.94589 8.14273 4.07137C8.14273 1.6432 6.32039 0 4.07137 0ZM4.07137 2.11711C5.15109 2.11711 6.02562 2.99164 6.02562 4.07137C6.02562 5.15109 5.15109 6.02562 4.07137 6.02562C2.99164 6.02562 2.11711 5.15109 2.11711 4.07137C2.11711 2.99164 2.99164 2.11711 4.07137 2.11711Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkMapg);
export default __webpack_public_path__ + "static/media/markMapg.20e8e08f322542fab063bc214156a0d4.svg";
export { ForwardRef as ReactComponent };